import dispatcher from '../../dispatcher';
// import cursorStore from '../../../modules/events/cursor.store';
// import popupStore from '../../../modules/popup/popup.store';
// import TweenMax from '../../../libs/TweenMax';

// в attach указать название анимации
// component._transitions.basic <- здесь название - basic
// start - начало анимации
// end - конец
// в data приходит вся transitionData

var name = 'basic-transition';

if (!window._registeredDecorators) {
	window._registeredDecorators = [];
}
if (window._registeredDecorators.indexOf(name) !== -1) {
	console.warn('error. decorator with name "' + name + '" already registered');
	// return;
} else {
	window._registeredDecorators.push(name);
}

function fadeTo(el, opacity, speed, delay) {
	var transition = 'opacity ' + speed + 's ease ' + delay + 's';
	if (!el || !el.style) return; // hi microsoft edge
	el.style.transition =
		el.style.webkitTransition = transition;
	el.style.opacity = opacity;
}

function translateTo(el, translate, opacity, speed, delay, easing) {
	var ease = easing || 'ease';
	var transition = 'transform ' + speed + 's ' + ease + ' ' + delay + 's,' +
		'opacity ' + speed + 's ' + 'ease' + ' ' + delay + 's';

	if (!el || !el.style) return; // hi microsoft edge

	el.style.transition =
		el.style.webkitTransition = transition;

	el.style.transform =
		el.style.webkitTransform = 'translateX(' + translate[0] + 'px)' +
			'translateY(' + translate[1] + 'px)' +
			'translateZ(' + translate[2] + 'px)';

	el.style.opacity = opacity;
}

function scaleTo(element, scale, speed) {
	element.style.transitionDuration = speed + 's';
	element.style.transform = 'scaleY(' + scale + ') translateZ(0)';
}

var _start = function(data) {
	var decorator = this._decorators[name];
	var self = this;
	var x, y;
	var pw = document.getElementsByClassName('page-wrapper')[0];
	var container;
	var delay = 100;

	if (data.container === 'replaceable') {
		container = document.getElementsByTagName('main')[0];
	} else {
		container = document.getElementsByClassName(data.container)[0];
	}

	if (data.copyElement) {
		this.copyElement(data.copyElement);
	}

	pw.classList.add('transition-active');
	container.style.pointerEvents = 'none';

	if (data.container === 'replaceable') {
		dispatcher.dispatch({
			type: 'content:hide',
			container: container
		});
		dispatcher.dispatch({
			type: 'page-load:reset'
		});
		dispatcher.dispatch({
			type: '3d:hide'
		});
	} else {
		delay = 0;
	}

	dispatcher.dispatch({
		type: 'popup:close-all'
	});
	dispatcher.dispatch({
		type: 'scroll:lock'
	});
	dispatcher.dispatch({
		type: 'popup:lock'
	});

	setTimeout(function() {
		fadeTo(container, 0, 0.6, 0);
	}, delay);

	setTimeout(function() {
		if (!data.noScroll) {
			window.scrollTo(0, 0);
		}
		if (!data.noShift) {
			// translateTo(container, [0, 40, 0], 0, 0, 0);
		}

		setTimeout(function() {
			dispatcher.dispatch({
				type: 'page-transition:check',
				step: 1
			});
		}, 20);
	}, 500 + delay);
}

var _end = function(data) {
	var decorator = this._decorators[name];
	var pw = document.getElementsByClassName('page-wrapper')[0];
	var scrollElement;

	var container;
	var h1;

	if (data.container === 'replaceable') {
		container = document.getElementsByTagName('main')[0];
	} else {
		container = document.getElementsByClassName(data.container)[0];
	}

	// скролл
	if (data.hash) {
		scrollElement = document.getElementById(data.hash);
	}
	if (scrollElement) {
		scrollPosition = utils.offset(scrollElement).top;
		window.scrollTo(0, scrollPosition);
	} else if (!data.noScroll) {
		window.scrollTo(0, 0);
	}

	container.style.pointerEvents = 'auto';

	// какие-то анимации могут быть здесь
	if (data.container === 'replaceable') {
		h1 = document.querySelector('.home h1');
		translateTo(h1, [-60, 0, 0], 0, 0, 0, 'ease');
	}

	// dispatcher.dispatch({
	// 	type: 'content:instant-hide',
	// 	container: container
	// });

	setTimeout(function() {
		pw.classList.remove('transition-active');

		translateTo(container, [0, 0, 0], 1, 0.8, 0, 'ease');
		if (data.container === 'replaceable') {
			translateTo(h1, [0, 0, 0], 1, 0.8, 0, 'cubic-bezier(0.25, 0.46, 0.45, 0.94)');
		}

		// dispatcher.dispatch({
		// 	type: 'content:show',
		// 	container: container
		// });

		dispatcher.dispatch({
			type: 'page-transition:check',
			step: 3
		});
		dispatcher.dispatch({
			type: 'scroll:unlock'
		});
		dispatcher.dispatch({
			type: 'gradient:hide'
		});
		dispatcher.dispatch({
			type: 'popup:unlock'
		});
		dispatcher.dispatch({
			type: 'page-load:load'
		});
		pw.classList.remove('popup-active')
	}, 20);
}

var attach = function(component) {
	var decorator = {};

	if (!component._decorators) {
		component._decorators = {};
	}
	component._decorators[name] = decorator;

	decorator.start = _start.bind(component);
	decorator.end = _end.bind(component);

	component._transitions.basic = {
		start: decorator.start,
		end: decorator.end
	}
}

var detach = function(component) {
	var decorator = component._decorators[name];
}

export default {
	attach: attach,
	detach: detach
};